import { concatPassengerNames, getPassengerNames } from '../../../../utils';
export function getPassengersInitialState(travellers, extraSeatIds) {
    return travellers.map(traveller => {
        var _a, _b, _c, _d;
        const { lastName, firstName } = getPassengerNames(traveller);
        const fullName = lastName || firstName ? concatPassengerNames({ lastName, firstName }) : null;
        return {
            lastName,
            firstName,
            fullName,
            id: +traveller.id,
            type: traveller.type,
            supplierTravellerType: traveller.supplierTravellerType,
            selectedSeats: (_b = (_a = traveller.services) === null || _a === void 0 ? void 0 : _a.seats) !== null && _b !== void 0 ? _b : [],
            preselectedSeats: traveller.preselectedServices.seats,
            activeDoubleSeat: !!((_d = (_c = traveller.services) === null || _c === void 0 ? void 0 : _c.gdsServices) === null || _d === void 0 ? void 0 : _d.services.some(service => extraSeatIds.includes(service.serviceId)))
        };
    });
}
